import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { HelperService } from '../../../services/helper.service';

@Component({
  selector: 'app-blueprintchoose',
  templateUrl: './blueprintchoose.dialog.html',
  styleUrls: ['./blueprintchoose.dialog.scss'],
})
export class BlueprintchooseDialog implements OnInit {

  constructor(private modalController: ModalController, private alertController: AlertController) { }

  ngOnInit() {}

  dismissModal() {
    this.modalController.dismiss();
  }

  async onClick(event) {
    const alert = await this.alertController.create({
      header: "Do you want to choose \"" + event.name + "\"?",
      subHeader: "Click 'OK' to continue",
      buttons: [
        {
          text: "Cancel",
          role: 'cancel'
        }, {
          text: "Ok",
          handler: ()=>{
            this.modalController.dismiss({name: event.name, id: event.id})
          }
        }
      ]
    });

    await alert.present();
  }

}
